import { createSelector } from 'reselect'

import { selectFinancialCockpitState } from './selectFinancialCockpitState'

export const selectCockpitKeyInitiatives = createSelector(
  [selectFinancialCockpitState],
  ({ keyInitiatives }) => keyInitiatives
)
